import { css, type Theme } from "@emotion/react";

export const link = (theme: Theme) => css`
  color: ${theme.success.textBase};
  white-space: nowrap;
  text-decoration: underline;
`;
